import { useQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickCountsResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// GNB 배지용 카운트(담은 상품 수 / 패스픽 주문 상품 수) 조회 훅.
// 상품 목록 API로 개수만 얻던 방식은 두 소스 조회·크림 조인까지 전부 돌아 4배 이상 느렸다.
const useGetPathPickCounts = () => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickCounts, isPending } = useQuery({
    queryKey: ["pathpick", "counts", companyId],
    queryFn: async () => {
      const data = await pathPickQueryApi.getPathPickCounts(
        companyId as number
      );
      return toCamelKeyObject(data) as PathPickCountsResponse;
    },
    enabled: Boolean(companyId),
  });

  return { pathPickCounts, isPending };
};

export default useGetPathPickCounts;
